import {loadable} from 'router/routes';
import getInitialState from './redux/get-initial-state';

const MidFunnelAirport = loadable(() => import('./MidFunnelAirport'));

MidFunnelAirport.getInitialState = getInitialState;

export default MidFunnelAirport;
